import { settings, updateSettings } from "../../../settings";
import type { Settings } from "../../../settings";
import { Select } from "../../components/Select";
import type { SelectOption } from "../../components/Select";

type NetworkSettings = Settings["network"];

const TRANSPORT_OPTIONS: readonly SelectOption<NetworkSettings["transport"]>[] = [
  { value: "auto", label: "Auto" },
  { value: "webtransport", label: "WebTransport" },
  { value: "websocket", label: "WebSocket" },
];

const TRANSPORT_HELP: Readonly<Record<NetworkSettings["transport"], string>> = {
  auto: "Prefers WebTransport and falls back to WebSocket when UDP is blocked or the browser lacks WebTransport.",
  webtransport: "Lowest latency, but needs UDP: it can fail on networks that block it.",
  websocket: "Works on any network over TCP. Slower to recover from packet loss.",
};

const INTERPOLATION_OPTIONS: readonly SelectOption<NetworkSettings["interpolation"]>[] = [
  { value: "auto", label: "Auto" },
  { value: "low", label: "Low" },
  { value: "high", label: "High" },
];

const INTERPOLATION_HELP: Readonly<Record<NetworkSettings["interpolation"], string>> = {
  auto: "Adapts the delay of other players to your connection's jitter and packet loss.",
  low: "Fixed 1.25 ticks (about 10 ms). Most responsive, may stutter on a shaky connection.",
  high: "Fixed 8 ticks (about 67 ms). Smoothest on a shaky connection, other players appear slightly later.",
};

export function NetworkTab() {
  const n = settings.value.network;

  return (
    <div class="settings__content">
      <h3 class="settings__group">Connection</h3>
      <div class="settings__rows">
        <Select
          class="settings__row--tall"
          label="Transport"
          description={TRANSPORT_HELP[n.transport]}
          value={n.transport}
          options={TRANSPORT_OPTIONS}
          onChange={(transport) => updateSettings({ network: { transport } })}
        />
        <Select
          class="settings__row--tall"
          label="Interpolation"
          description={INTERPOLATION_HELP[n.interpolation]}
          value={n.interpolation}
          options={INTERPOLATION_OPTIONS}
          onChange={(interpolation) => updateSettings({ network: { interpolation } })}
        />
      </div>
    </div>
  );
}
